import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import LoginPage from './pages/page-login';
import PrivateRoutes from './components/private-route';
import './styles/App.css';
import { AccountPage } from './pages/page-account';
import { AlarmsPage } from './pages/page-alarms';
import { CutRecordsPage } from './pages/page-cutRecords';
import { OrganizationsPage } from './pages/page-organizations';
import { OEEPage } from './pages/page-oee';
import { SpoolWindersPage } from './pages/page-spoolWinders';
import { UsersPage } from './pages/page-users';
import AccountConfirmPage from './pages/page-accountConfirm';

export default class App extends React.Component {

  public render() {

    return (
      <Router history={createBrowserHistory()}>
        <Switch>

          <Route path='/login' exact={false} component={LoginPage} />
          <Route path='/confirm/:email?:token?' exact={true} component={AccountConfirmPage} />

          <PrivateRoutes>
            <Switch>
              <Route path="(/|/main|/index.html|/spoolWinders)" exact={false} component={SpoolWindersPage} />
              <Route path="(/cutRecords)" exact={true} component={CutRecordsPage} />
              <Route path="(/alarms)" exact={true} component={AlarmsPage} />
              <Route path="(/oee)" exact={true} component={OEEPage} />
              <Route path="(/users)" exact={true} component={UsersPage} />
              <Route path="(/organizations)" exact={true} component={OrganizationsPage} />
              <Route path="(/account)" exact={true} component={AccountPage} />
            </Switch>
          </PrivateRoutes>

        </Switch>
      </Router>
    );
  }
}